module.exports = __webpack_public_path__ + "assets/img/dzh-14.0cb6fd28.gif";